import { NgModule } from '@angular/core';
import { AiTextButtonComponent } from './ai-text-button.component';

@NgModule({
  imports: [AiTextButtonComponent],
  exports: [AiTextButtonComponent],
})
export class GalaxyAITextButtonModule {}
